module.exports = __webpack_public_path__ + "static/media/Toxicroak_gaussian2.2e11c4e1.png";